<template>
  <transition name='fade'>
    <div class="modal share_box"
         v-if='visible'>
      <div class="share"
           @click.stop='closeQrcode()'>
        <div class="title msp_icon_close">
          <span class="title_name">分享详情</span>
          <span class="iconfont el-icon-close"
                @click.stop='closeBox()'></span>
        </div>
        <div class="share_parameter">
          <div class="parameter"
               style="margin-bottom:14px;"
               v-if='shareInfoType === "myshareouter"'>
            <span>安全设置：</span>
            <el-checkbox v-model="safeChecked"></el-checkbox>
            <span style="margin-right:14px;margin-left:6px;">加密分享</span>
            <el-input v-model="codeInput"
                      placeholder=""
                      disabled
                      v-show='safeChecked'></el-input>
            <span class="code_title"
                  style="margin-left:14px;"
                  v-show='safeChecked'>提取码</span>
          </div>
          <div class="parameter"
               v-if='shareInfoType === "myshareouter"'>
            <span>失效日期：</span>
            <el-checkbox v-model="failureDateChecked"></el-checkbox>
            <span style="margin-right:14px;margin-left:6px;">永久有效</span>
            <el-date-picker v-model="failureDateInput"
                            type="date"
                            :clearable='false'
                            placeholder="选择日期"
                            value-format='timestamp'
                            @change='choiceLostEffectTime'
                            :picker-options='pickerOptions'
                            v-show="!failureDateChecked">
            </el-date-picker>
          </div>
          <div class="parameter">
            <span>权限选择：</span>
            <el-checkbox v-model="editorChecked"
                         :disabled='shareInfoType == "shareTomeInner"'></el-checkbox>
            <span style="margin-right:14px;margin-left:6px;"
                  v-if="shareData.doc_type!='document'">编辑稿件</span>
            <span style="margin-right:14px;margin-left:6px;"
                  v-if="shareData.doc_type=='document'">编辑文档</span>
          </div>

          <div class="parameter">
            <span>备注说明：</span>
            <el-input type="textarea"
                      v-model="remarkDescrip"
                      show-word-limit
                      :maxlength='100'
                      :disabled='shareInfoType == "shareTomeInner"'>
            </el-input>
          </div>
          <div class="parameter"
               v-if='shareInfoType === "myshareouter"'>
            <span>分享链接：</span>
            <span class="share_url_link_detail">{{shareUrlLink}}</span>
          </div>

          <div class="parameter"
               v-if='shareInfoType ==="myshareInner"'>
            <span>分享给：</span>
            <div class="parameter_each">
              <span v-for="item in shareUsers">{{item.sharedUserName}}</span>
            </div>
          </div>

        </div>
        <div class="share_object"
             v-if='shareInfoType ==="myshareouter" || shareInfoType ==="myshareInner"'>
          <div class="share_object_button">
            <el-button type="primary"
                       style="margin-left:20px;"
                       @click.native='shareStatusChange("save")'>保存</el-button>

            <el-button type="primary"
                       style="margin-left:20px;"
                       v-if="shareStatus === 'doing'"
                       @click.native='shareStatusChange("close")'>关闭分享</el-button>
            <el-button type="primary"
                       style="margin-left:20px;"
                       v-if="shareStatus === 'close'"
                       @click.native='shareStatusChange("doing")'>开启分享</el-button>
            <el-button type="primary"
                       style="margin-left:20px;"
                       v-if='shareInfoType ==="myshareouter" && shareStatus !== "close"'
                       @click.native='shareStatusChange("copy")'>复制链接</el-button>
          </div>

        </div>

      </div>

      <div style="position:absolute;left:99999999px;top:99999999999px;">
        <input type="text"
               v-model="copyShareLink"
               id='share_url_link_detail'>
      </div>

    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'




export default {
  name: 'sharetype',
  data() {
    return {
      visible: false,
      safeChecked: true,
      codeInput: '',
      lookChecked: true,
      editorChecked: true,
      failureDateChecked: true,
      failureDateInput: '',
      remarkDescrip: '',
      shareData: '',
      timeLostSize: 0,
      shareUrlLink: '',
      isShowQrcode: false,
      shareInfoType: '',
      shareUsers: [],
      shareStatus: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }

    }
  },
  mounted() {
    this.$root.eventHub.$on('shareInformationModel', (data, type) => {
      this.visible = true
      this.shareData = data
      this.shareInfoType = type
      this.editorChecked = data.canEdit
      if (data.code) {
        this.safeChecked = true
        this.codeInput = data.code
      } else {
        this.safeChecked = false
        this.getSafeCode()
      }
      if (data.invalidTime >= 2865686400000) {
        this.failureDateChecked = true
      } else {
        this.failureDateChecked = false
        this.failureDateInput = data.invalidTime
      }
      this.remarkDescrip = data.remarks
      this.shareUsers = data.shareUserShips
      this.shareStatus = data.status
      this.shareUrlLink = data.articleUrl
    })
  },
  destroyed() {
    this.$root.eventHub.$off('shareInformationModel')
  },
  computed: {
    copyShareLink() {
      if (this.safeChecked) {
        return this.shareUrlLink + '【' + this.shareData.title + '】' + '提取码：' + this.codeInput
      } else {
        return this.shareUrlLink + '【' + this.shareData.title + '】'
      }

    }
  },

  methods: {
    closeBox() {
      this.visible = false
    },
    choiceLostEffectTime(value) {
      if (value) {
        this.failureDateChecked = false
        this.timeLostSize = value
      } else {
        this.failureDateChecked = true
        this.timeLostSize = 0
      }

    },

    //获取code
    getSafeCode() {
      api._get(_SHAREURL_ + 'getSixCodeAndId' + '?shareId=' + this.shareData.id, '').then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.codeInput = res.data.code
          }

        } else {
          this.codeInput = ''
        }
      }).catch((error) => {
        console.log(error)
        this.codeInput = ''
      })
    },

    shareStatusChange(type) {
      var shareStatus = ''
      if (type == "close" || type == 'doing') {
        shareStatus = type
      } else if (type === 'copy') {
        shareStatus = 'doing'
      } else if (type == 'save') {
        shareStatus = this.shareStatus
      }

      this.isShowQrcode = false
      var url = _SHAREURL_ + 'editById'
      var code = ''
      if (this.safeChecked) {
        code = this.codeInput
      } else {
        code = ''
      }


      var option = {
        ...this.$store.getters.baseOption,
        "params": {                           // 必须字段： 参数
          "canEdit": this.editorChecked,                                     //能否编辑
          "invalidTime": this.timeLostSize,                         //失效日期
          "remarks": this.remarkDescrip,                         //备注
          'code': code,
          'id': this.shareData.id,
          'status': shareStatus
        }
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.$notify.success({
            title: '成功',
            message: '更新成功'
          });

          if (type === 'copy') {
            this.copyTextareaCode()
          }
          this.$set(this.shareData, 'code', res.data.code)
          this.$set(this.shareData, 'invalidTime', res.data.invalidTime)
          this.$set(this.shareData, 'canEdit', res.data.canEdit)
          this.$set(this.shareData, 'remarks', res.data.remarks)
          this.$set(this.shareData, 'status', res.data.status)
          this.$set(this.shareData, 'articleUrl', res.data.articleUrl)
          this.$root.eventHub.$emit('shareInformationModel', this.shareData, this.shareInfoType)

        }
      }).catch((error) => {
        console.log(error)
      })

    },
    copyTextareaCode() {
      this.$nextTick(() => {
        if (this.copyShareLink) {
          var codeText = document.getElementById('share_url_link_detail');
          codeText.select(); // 选择对象
          document.execCommand("Copy")
          this.$notify.success({
            title: '成功',
            message: '复制成功'
          });
        } else {
          this.$notify.error({
            title: '失败',
            message: '复制失败'
          });
        }

      })

    },

    closeQrcode() {
      this.isShowQrcode = false
    }
  },
  watch: {
    shareData() {
      if (this.shareData.length === 0) {
        this.visible = false
      }
    },
    failureDateChecked() {
      if (this.failureDateChecked) {
        this.timeLostSize = 0
      } else {
        this.timeLostSize = this.failureDateInput
      }

    },
    visible() {
      if (!this.visible) {
        this.safeChecked = true
        this.failureDateChecked = true
        this.editorChecked = true
        this.remarkDescrip = ''
      }
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.share_box
  .share
    min-height 250px
    width 500px
    border-radius 6px
    background #fff

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 50px
      border-bottom 1px solid #E6E7EB

      .title_name
        span-medium-title()
        float left
        line-height 50px

      .iconfont
        float right
        font-size 18px
        line-height 50px
        cursor pointer

    .share_parameter
      box-sizing border-box
      margin-bottom 14px
      padding-top 24px
      padding-left 78px
      width 100%

      .parameter
        display flex
        margin-bottom 4px
        width 100%

        span
          input-title()
          line-height 36px

        span.code_title
          time-title()

        .parameter_each
          flex 1
          word-break break-all

          span
            margin-right 10px

        .share_url_link_detail
          display inline-block
          flex 1
          margin-right 10px
          word-break break-all

    .share_object
      box-sizing border-box
      margin-left 78px
      padding-top 20px
      padding-bottom 20px
      width 340px
      border-top 1px dashed #E6E7EB

      .share_object_button
        display flex
        justify-content flex-end

        button
          padding 0px
          width 72px
          height 32px
          line-height 32px
</style>
